import React, { Component } from "react";
import {Row, Col, Label, FormText, Button} from 'reactstrap';
// import CsvColumn from '../CsvColumn';
import './MatchColumn.css';
import Select from 'react-select';
import { mapType } from "../../../../../utils/constants";

export default class MatchColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matchedValue: false,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }


  onMatch = (value) => {
    if (value!==null && (value.value ==="seniority" ||value.value ==="occupation" ) && value.value && value.length !==2){
      // let bool = value.value ==="seniority" || value.value ==="occupation"?true:false 
      // console.log(value.value, '-- bool -',bool)
      this.setState({matchedValue: true})
    }
    if(value!==null&&value.length !==undefined &&value.length ===2){
      this.setState({matchedValue: true})
    }
    value = value === null || value.length===0 || value === undefined || value==="undefined"? null: value
    this.props.onColumnMatch(value)
   }

  
  
 render() {
    let {csvField, csvData, matched,type,showDropdown,dropdownValue,
      allowDropdownMultiselect,dropdownValues} = this.props;
    let borderStyle = {borderBottom : matched ? '1px solid #BCEDE4' : '1px solid #FFE4DE'};




    let multiBool = matched && (this.state.matchedValue ===true || dropdownValue==="occupation(s)"|| dropdownValue==="seniority") ? true:false
    let values;
    if(dropdownValue){
      if(dropdownValue.value.length >1) {
        values =  dropdownValue.value.map(e=> e)
        multiBool = matched && (this.state.matchedValue ===true || (values!==null && (values[0].value ==="seniority" || values[0].value ==="occupation" || values[1].value ==="seniority" || values[1].value ==="occupation" )));
      } else {
        let val = dropdownValue.value
        if(Array.isArray(val)){
          values = dropdownValue.value[0]
          multiBool = matched && (this.state.matchedValue ===true || (values!==null && (values.value ==="seniority" || values.value ==="occupation" )));
        } else {
          values = dropdownValue.value
        }
      }
    }

    return (
      <div className={matched ? 'matched-column mb20' : 'unmatched-column mb20'} style={{borderRadius: '5px'}}>
        <div style= {borderStyle} className={'csv-column-section d-flex flex-column justify-content-center align-items-center'.concat(matched ? ' matched-sec-bg' : ' unmatched-sec-bg')}>
            <div className="text-center csv-column-txt limitTo2Lines">
            {csvField}
            </div>
            {
              showDropdown ? 
              <div style={{width:'100%'}}>
                <div className="pl10 pr10 mt10" style={{width:'100%'}}>
                  <Select
                    value={dropdownValue ? values : null}
                    options={dropdownValues && (values!==undefined&&values.length<3?false:true)? dropdownValues :null}
                    onChange={(value) => this.onMatch(value)}
                    clearable={mapType.uploadEmployeeDataCsv ? true : false}
                      // multi={allowDropdownMultiselect}
                    multi={multiBool || (values&&values.length)>1?true:false}
                  />
                </div>
                <div className="text-center mt10">
                  {matched ? <span className="matched-column-txt">(matched column)</span> : <span className="unmatched-column-txt">(unmatched column)</span>}
                </div>
              </div> :
              <div>
                { type == "Perfomance" || type == "Separation" ?
                  <div>
                    <div className="text-center mt10">
                      {
                        matched ? 
                        <span className="matched-column-txt">(matched column)</span> : 
                        <span className="unmatched-column-txt">(unmatched column)</span>
                      }
                    </div>
                    <div className="text-center mt10 pl10 pr10" style={{width:'100%'}}>
                      {
                        matched ? 
                        <span className="unmatch" onClick={this.props.onColumnUnMatch}>Unmatch</span> : 
                        <span className="match" onClick={this.props.onColumnMatch}>Match</span>
                      }
                    </div>
                  </div> :
                  <div>
                    <div className="text-center mt10">
                      { 
                        matched ? 
                        <span className="matched-column-txt">(selected column)</span> :
                        <span className="unmatched-column-txt">(unselected column)</span>
                      }
                    </div>
                    <div className="text-center mt10 pl10 pr10" style={{width:'100%'}}>
                      { 
                        matched ? 
                        <span className="unmatch" onClick={this.props.onColumnUnMatch}>Unselect</span> :
                        <span className="match" onClick={this.props.onColumnMatch}>Select</span>
                      }
                    </div>
                  </div>
                }
              </div>
            }
            {matched ? <div className="text-center mt10">
              <i className="material-icons" style={{color: '#1EC4B4', fontSize: '30px'}}>check_circle</i>
            </div> : null}
        </div>
        <div className="csv-records-section">
          {csvData && csvData.length > 0 ? <div className="csvFieldValue" style= {borderStyle}>{csvData[0][csvField]}</div> : null}
          {csvData && csvData.length > 1 ? <div className="csvFieldValue" style= {borderStyle}>{csvData[1][csvField]}</div> : null}
          {csvData && csvData.length > 2 ? <div className="csvFieldValue">{csvData[2][csvField]}</div> : null}
        </div>
     </div>
     )
  }
}